import { render, staticRenderFns } from "./Changelog.vue?vue&type=template&id=8bca4466&scoped=true"
import script from "./Changelog.vue?vue&type=script&lang=js"
export * from "./Changelog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bca4466",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/print-suite/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8bca4466')) {
      api.createRecord('8bca4466', component.options)
    } else {
      api.reload('8bca4466', component.options)
    }
    module.hot.accept("./Changelog.vue?vue&type=template&id=8bca4466&scoped=true", function () {
      api.rerender('8bca4466', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/users/Changelog.vue"
export default component.exports